export const QuarantineNotifierException = 'QuarantineNotifierException'
